// @flow
import * as React from "react";

import AuthService from "services/auth";

import { Navigate, useLocation } from "react-router-dom";

type Props = {|
  element: React.Node,
|};

function PrivateRoute({ element }: Props): React.Node {
  const location = useLocation();

  if (AuthService.isAuthenticated()) {
    return element;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
}

export default PrivateRoute;
